/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type CartPrice_item$ref = any;
export type CartPrice_item = {
    readonly setSize: number | null;
    readonly hasUnlimitedQuantity: boolean | null;
    readonly quantity: number | null;
    readonly " $refType": CartPrice_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartPrice_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "setSize",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "hasUnlimitedQuantity",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "quantity",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = '47a027f1afa22176e6c1ceea2e369631';
export default node;
